<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Edit Passmark
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="12">
          <v-form>
            <v-text-field
              :error-messages="messages.pass_mark"
              v-model="pass_mark"
              label="Passmark"
              type="text"
              filled
            ></v-text-field>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="grey300" class="cancel-button"  @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" class="ml-4 add-course-button"  @click="updatePassmark"
          >Update Passmark</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import testAPI from "@/api/test.js";
export default {
  name: "EditPassmark",
  components: {},
  props: {
    id: {
      type: String,
      default: null
    },
    passMark: {
      type: Number,
      default: 80
    }
  },
  data() {
    return {
      quiz: {},
      pass_mark: 0,
      answers: {},
      messages: {},
      loading: false,
      successMessage: "Passmark has been added",
      errorMessage: "Oops something went wrong"
    };
  },
  computed: {},
  mounted() {
    this.pass_mark = this.passMark;
    
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    updatePassmark() {
      testAPI
        .updatePassmark(this.id, this.pass_mark)
        .then((resp) => {
          this.closePanel();
          EventBus.$emit("PASSMARK_UPDATED", resp.data.data);
          this.$snotify.success(this.successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  }
};
</script>
